module.exports = __webpack_public_path__ + "img/video.eef11b5.webp";